import React from "react";
import { useFormikContext } from "formik";
import MessageTextBox from "../../../pages/Campaigns/migrate/messages/MessageTextBox";
import PropTypes from "prop-types";
import Template from "../Template";
import ShortUrls from "./ShortUrls";
const MessageText = ({ step }) => {
  const { values, setFieldValue, errors, touched, handleBlur } =
    useFormikContext();
  return (
    <div className="bg-white py-3 rounded-lg">
      <div className="px-4">
        <div className="flex items-end gap-2 my-2">
          <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
            <span className="font-bold">{step}</span>
          </div>
          <div className="text-xl font-bold text-gray-600">Mensaje SMS</div>
        </div>

        <MessageTextBox
          value={values.message}
          onChange={(e) => setFieldValue("message", e.target.value)}
          name="message"
          onBlur={handleBlur}
          isError={errors && errors.message}
          errorMsg={errors && touched ? errors.message : ""}
          template={values.template}
          fieldsInfo={values.fieldsInfo}
        />
        <div className="grid grid-cols-2 gap-4 rounded-lg border my-1">
          <Template
            onChange={(e) => setFieldValue("message", e)}
            value={values.message}
          />
          <ShortUrls
            onChange={(e) => setFieldValue("message", e)}
            value={values.message}
          />
        </div>
      </div>
    </div>
  );
};

MessageText.propTypes = {
  step: PropTypes.number,
  handleTemplate: PropTypes.func,
};

export default MessageText;
